import React from "react";
import ReactTooltip from "react-tooltip";
import { handleTooltip } from "../../../utils/handleToolTip";

const InfoTooltip = ({ style, title, tooltipId }) => (
  <>
    <span
      className="glyphicon glyphicon-info-sign"
      style={style}
      data-for={tooltipId}
      data-tip={handleTooltip(title)}
    />
    <ReactTooltip
      id={tooltipId}
      place="bottom"
      class="custom-tooltip"
      textColor="#ffffff"
      backgroundColor="#000000"
    />
  </>
);

export default InfoTooltip;
